import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableMapSet, enablePatches } from 'immer';

import { environment } from '@coin/shared/core/util-environments';
import { AppModule } from './app/app.module';

// Immer resolves its Map/Set support lazily from inside a proxy get trap, so the plugin
// must be registered before the first `produce` that drafts a Map or Set. Registering it in
// a lazy feature module made that a load-order race (GMTEC-24514).
enableMapSet();
enablePatches();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.warn(err));
